module.exports = __webpack_public_path__ + "static/media/gradient-background.2c4c26a1.jpg";